import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import element from component folder */
import Table from "../../modelTable";

/* import function from store folder */
import { setModel } from '../../../store/components/modelSlice';
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import fetch function */
import { GiveEventPoints } from "../../../services/events";

const PointEvent = () => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.model);

    const cancelHandler = () => dispatch(resetModel());
    
    const modelHandler = modelType => {
        const _source = Object.assign({}, data);

        dispatch(setModel({type: modelType, data: _source}));
    };

    const submitHandler = event => {
        event.preventDefault();
        const _source = Object.assign({}, data);

        _source.point = _source.reward;

        delete _source.reward;
        delete _source.content;
        delete _source.eventName;

        GiveEventPoints(_source).then(response => {
            if (!Object.keys(response).length) {
                cancelHandler();
                dispatch(setAction());
            }
        });
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Give Members Points</Modal.Header>
            <Modal.Body>
                <div className="modal-form-container">
                    <div className="form-item">
                        <div className='label'>Event Name</div>
                        <span className='semicolon'>：</span>
                        <span className='text'>{ data.eventName }</span>
                    </div>
                    <div className="form-item">
                        <div className='label'>Points</div>
                        <span className='semicolon'>：</span>
                        <span className='text'>{ data.reward }</span>
                    </div>
                    <div className="form-table-item">
                    <Table header={ [
                            { key: 'email', value: 'Email' },
                            { key: 'firstName', value: 'First Name' },
                            { key: 'lastName', value: 'Last Name' }
                            ] } body={ data.content } totalCount={ data.content.length } />
                    </div>  
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ () => modelHandler('point-event') }>Back</Button>                        
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PointEvent;